'use strict';

import getNgModule from "getNgModule";
var ngModule = getNgModule(__filename);
ngModule.directive('tlChecklistModel', function ($parse) {
  return {
    restrict: 'A',
    scope: {
      tlChecklistModel: "=",
      tlChecklistValue: "="
    },
    link: function link($scope, $el, $attrs) {
      $scope.checked = false;

      // value added to list
      var value = $parse($attrs.tlChecklistValue)($scope.$parent);
      $el.on('click', function () {
        $scope.$apply(function () {
          $scope.checked = $el.is(":checked");
        });
      });

      // watch UI checked change
      $scope.$watch('checked', function (isChecked, oldValue) {
        $el.prop('checked', isChecked);
        if (isChecked === oldValue) {
          return;
        }
        var list = $scope.tlChecklistModel;
        if (!list) {
          return;
        }
        if (isChecked === true) {
          if (!_.includes(list, value)) {
            list.push(value);
            // setter($scope.$parent, current);
          }
        } else {
          var position = _.indexOf(list, value);
          if (position > -1) {
            list.splice(position, 1);
            // setter($scope.$parent, current);
          }
        }
      });

      // watch original model change
      $scope.$watchCollection("tlChecklistModel", function (newArr) {
        if (!newArr) {
          $scope.checked = false;
        } else {
          $scope.checked = _.includes(newArr, $scope.tlChecklistValue);
        }
      });
    }
  };
});


//////////////////
// WEBPACK FOOTER
// ./src/modules/common/ng/tl/tlChecklistModel.js
// module id = 2898
// module chunks = 13